import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import api from '../api/axios';
import { formatImageUrl } from '../utils/formatImageUrl';

const fallbackBannerData = [
    {
        img: "/assets/images/bg/banner-bg.png",
        title: "Daily Grocery Order and Get Express Delivery",
        titleClass: "banner-item__title bounce",
        btnText: "Explore Shop",
        btnIcon: "ph-shopping-cart-simple",
    },
    {
        img: "/assets/images/bg/banner-bg2.png",
        title: "Best Deals On Fresh Fruits and Vegetables",
        titleClass: "banner-item__title",
        btnText: "Shop Now",
        btnIcon: "ph-shopping-bag-open",
    },
];

const BannerOne = () => {
    const [current, setCurrent] = useState(0);
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const res = await api.get('/api/hero-slides');
                if (res.data && res.data.length > 0) {
                    setBanners(res.data);
                } else {
                    setBanners(fallbackBannerData);
                }
            } catch (err) {
                console.error("Failed to fetch banners", err);
                setBanners(fallbackBannerData);
            } finally {
                setLoading(false);
            }
        };
        fetchBanners();
    }, []);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }
    const isMultiple = banners.length > 1;

    const settings = {
        dots: false,
        arrows: isMultiple,
        infinite: isMultiple,
        speed: 600,
        cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: isMultiple ? <SampleNextArrow /> : null,
        prevArrow: isMultiple ? <SamplePrevArrow /> : null,
        afterChange: (index) => setCurrent(index),
        autoplay: isMultiple,
        autoplaySpeed: 4500,
        pauseOnHover: false,
    };

    if (loading) return null;

    const currentBanner = banners[current] || banners[0] || fallbackBannerData[0];
    const currentBannerImg = formatImageUrl(currentBanner.image || currentBanner.img, '/assets/images/bg/banner-bg.png');

    const renderSlideContent = (banner) => (
        <div className="banner-slider__inner flex-between position-relative">
            <div className="banner-item__content">
                {banner.subtitle && (
                    <span className="banner-item__subtitle d-block text-main-600 fw-semibold mb-8 wow fadeInDown" data-wow-delay="0.1s">
                        {banner.subtitle}
                    </span>
                )}
                <h1 className={`${banner.titleClass || "banner-item__title"} wow fadeInUp`} data-wow-delay="0.2s">
                    {banner.title}
                </h1>
                <Link
                    to={banner.url || "/shop"}
                    className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8 wow zoomIn hover-lift"
                    data-wow-delay="0.3s"
                >
                    {banner.btnText || "Explore Shop"}{" "}
                    <span className="icon text-xl d-flex">
                        <i className={`ph ${banner.btnIcon || "ph-shopping-cart-simple"}`} />{" "}
                    </span>
                </Link>
            </div>
        </div>
    );

    return (
        <div className="banner">
            <div className="container container-lg"  >
                <div className="banner-item rounded-24 overflow-hidden position-relative arrow-center"  >
                    <a
                        href="#featureSection"
                        className="scroll-down w-84 h-84 text-center flex-center bg-main-600 rounded-circle border border-5 text-white border-white position-absolute start-50 translate-middle-x bottom-0 hover-bg-main-800"
                    >
                        <span className="icon line-height-0">
                            <i className="ph ph-caret-double-down" />
                        </span>
                    </a>
                    <div className="banner-img-wrap position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1 overflow-hidden rounded-24">
                        <img
                            key={current}
                            src={currentBannerImg}
                            alt=""
                            className="banner-img banner-img-zoom w-100 h-100 object-fit-cover"
                        />
                    </div>
                    <style>{`
                        @keyframes bannerZoom {
                            0% { transform: scale(1); }
                            100% { transform: scale(1.15); }
                        }
                        .banner-img-zoom {
                            animation: bannerZoom 6s ease-in-out infinite alternate;
                        }
                    `}</style>
                    <div className="flex-align">


                    </div>
                    <div className="banner-slider">
                        {isMultiple ? (
                            <Slider {...settings}>
                                {banners.map((banner, index) => (
                                    <div className="banner-slider__item" key={banner.id || index}>
                                        {renderSlideContent(banner)}
                                    </div>
                                ))}
                            </Slider>
                        ) : banners.length === 1 ? (
                            <div className="banner-slider__item">
                                {renderSlideContent(banners[0])}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BannerOne